import { combineReducers } from '@reduxjs/toolkit'
import page from './page'
import section from './section'
import activepage from './activepage'

const tracking = combineReducers({
  page,
  section,
  activepage,
})

export type TrackingState = ReturnType<typeof tracking>

export default tracking
